export default __webpack_public_path__ + "static/media/tutorial.bdd48ce9.svg";